(() => {
  if (window.__essenceInfiniteScrollLoaded) {
    return;
  }

  window.__essenceInfiniteScrollLoaded = true;

  const stateBySection = new WeakMap();
  let refreshTimer = null;

  const SELECTORS = {
    root:
      '[data-essence-infinite-scroll="true"]' +
      '[data-essence-infinite-scroll-section]',

    productList:
      'product-list[id^="product-list-"]',

    pagination:
      '.pagination',

    nextLink:
      '.pagination a[rel="next"]',

    status:
      '.essence-infinite-scroll-status',

    spinner:
      '.essence-infinite-scroll__spinner',

    statusText:
      '.essence-infinite-scroll__text'
  };

  const TEXT = {
    loading: 'טוען מוצרים נוספים…',
    error:
      'לא הצלחנו לטעון מוצרים נוספים. אפשר להמשיך באמצעות העמודים.'
  };

  const setStatus = (
    state,
    mode,
    message = ''
  ) => {
    const {
      status,
      spinner,
      statusText
    } = state;

    if (
      !status ||
      !statusText
    ) {
      return;
    }

    status.dataset.state = mode;
    statusText.textContent = message;

    if (spinner) {
      spinner.hidden =
        mode !== 'loading';
    }

    if (
      mode === 'hidden' ||
      mode === 'finished'
    ) {
      status.hidden = true;
      return;
    }

    status.hidden = false;
  };

  const revealPaginationFallback = (
    state
  ) => {
    state.shopifySection.classList.remove(
      'essence-infinite-scroll--active'
    );
  };

  const cleanupState = (
    state
  ) => {
    if (state.observer) {
      state.observer.disconnect();
    }

    if (state.abortController) {
      state.abortController.abort();
    }

    state.shopifySection.classList.remove(
      'essence-infinite-scroll--active'
    );
  };

  const getNextUrl = (
    state
  ) => {
    const link =
      state.root.querySelector(
        SELECTORS.nextLink
      );

    return link
      ? link.href
      : null;
  };

  const placeStatusAfterProducts = (
    state
  ) => {
    /*
     * Move the observer/loader into the product grid.
     * This prevents tall collection layouts or filter
     * sidebars from pushing the loading trigger far below
     * the actual final product row.
     */
    if (
      state.status.parentElement !==
      state.productList
    ) {
      state.productList.appendChild(
        state.status
      );
    }
  };

  const replacePagination = (
    state,
    newSection
  ) => {
    const currentPagination =
      state.root.querySelector(
        SELECTORS.pagination
      );

    const newPagination =
      newSection.querySelector(
        SELECTORS.pagination
      );

    if (
      currentPagination &&
      newPagination
    ) {
      currentPagination.replaceWith(
        document.importNode(
          newPagination,
          true
        )
      );

      return;
    }

    if (
      currentPagination &&
      !newPagination
    ) {
      currentPagination.remove();
      return;
    }

    if (
      !currentPagination &&
      newPagination
    ) {
      const collectionMain =
        state.root.querySelector(
          '.collection__main'
        );

      if (collectionMain) {
        collectionMain.appendChild(
          document.importNode(
            newPagination,
            true
          )
        );
      }
    }
  };

  const prepareLoadedProduct = (item) => {
  const revealNodes = [
    item,
    ...item.querySelectorAll(
      '[reveal-on-scroll], [reveal]'
    )
  ];

  revealNodes.forEach((node) => {
    node.removeAttribute('reveal-on-scroll');
    node.removeAttribute('reveal');
    node.removeAttribute('hidden');

    node.style.setProperty(
      'opacity',
      '1',
      'important'
    );

    node.style.setProperty(
      'visibility',
      'visible',
      'important'
    );
  });

  return item;
};

  const loadNextPage = async (
    state
  ) => {
    if (
      state.loading ||
      state.finished
    ) {
      return;
    }

    const nextUrl =
      getNextUrl(state);

    if (!nextUrl) {
      state.finished = true;

      if (state.observer) {
        state.observer.disconnect();
      }

      setStatus(
        state,
        'finished'
      );

      return;
    }

    state.loading = true;
    state.abortController =
      new AbortController();

    setStatus(
      state,
      'loading',
      TEXT.loading
    );

    try {
      const requestUrl =
        new URL(
          nextUrl,
          window.location.origin
        );

      requestUrl.searchParams.set(
        'section_id',
        state.sectionId
      );

      const response =
        await fetch(
          requestUrl.toString(),
          {
            credentials:
              'same-origin',

            signal:
              state.abortController.signal,

            headers: {
              'X-Requested-With':
                'XMLHttpRequest'
            }
          }
        );

      if (!response.ok) {
        throw new Error(
          `HTTP ${response.status}`
        );
      }

      const html =
        await response.text();

      const parsedDocument =
        new DOMParser()
          .parseFromString(
            html,
            'text/html'
          );

      const newSection =
        parsedDocument.querySelector(
          '.shopify-section'
        );

      const newProductList =
        parsedDocument.getElementById(
          `product-list-${state.sectionId}`
        );

      if (
        !newSection ||
        !newProductList
      ) {
        throw new Error(
          'The next collection section could not be parsed.'
        );
      }

      const newItems =
        Array.from(
          newProductList.children
        ).filter(
          (item) =>
            !item.classList.contains(
              'essence-infinite-scroll-status'
            )
        );

      if (!newItems.length) {
        state.finished = true;

        if (state.observer) {
          state.observer.disconnect();
        }

        setStatus(
          state,
          'finished'
        );

        return;
      }

      const fragment =
        document.createDocumentFragment();

     newItems.forEach((item) => {
  const importedItem =
    document.importNode(
      item,
      true
    );

  prepareLoadedProduct(
    importedItem
  );

  fragment.appendChild(
    importedItem
  );
});

      /*
       * Insert new products before the loader so the
       * loader always remains the final grid item.
       */
      state.productList.insertBefore(
        fragment,
        state.status
      );

      replacePagination(
        state,
        newSection
      );

      document.dispatchEvent(
        new CustomEvent(
          'essence:collection:products-appended',
          {
            detail: {
              sectionId:
                state.sectionId,

              count:
                newItems.length
            }
          }
        )
      );

      if (getNextUrl(state)) {
        setStatus(
          state,
          'idle'
        );
      } else {
        state.finished = true;

        if (state.observer) {
          state.observer.disconnect();
        }

        setStatus(
          state,
          'finished'
        );
      }
    } catch (error) {
      if (
        error.name ===
        'AbortError'
      ) {
        return;
      }

      console.error(
        '[Essence Infinite Scroll]',
        error
      );

      if (state.observer) {
        state.observer.disconnect();
      }

      revealPaginationFallback(
        state
      );

      setStatus(
        state,
        'error',
        TEXT.error
      );
    } finally {
      state.loading = false;
      state.abortController = null;
    }
  };

  const createState = (
    root
  ) => {
    const shopifySection =
      root.closest(
        '.shopify-section'
      );

    if (!shopifySection) {
      return null;
    }

    const sectionId =
      root.dataset
        .essenceInfiniteScrollSection;

    const productList =
      root.querySelector(
        SELECTORS.productList
      );

    const status =
      root.querySelector(
        SELECTORS.status
      );

    if (
      !sectionId ||
      !productList ||
      !status
    ) {
      return null;
    }

    const state = {
      root,
      shopifySection,
      sectionId,
      productList,
      status,

      spinner:
        status.querySelector(
          SELECTORS.spinner
        ),

      statusText:
        status.querySelector(
          SELECTORS.statusText
        ),

      observer: null,
      abortController: null,
      loading: false,
      finished: false
    };

    placeStatusAfterProducts(
      state
    );

    state.observer =
      new IntersectionObserver(
        (entries) => {
          const shouldLoad =
            entries.some(
              (entry) =>
                entry.isIntersecting
            );

          if (shouldLoad) {
            loadNextPage(
              state
            );
          }
        },
        {
          root: null,
          rootMargin:
            '900px 0px',
          threshold: 0
        }
      );

    shopifySection.classList.add(
      'essence-infinite-scroll--active'
    );

    if (!getNextUrl(state)) {
      state.finished = true;

      setStatus(
        state,
        'finished'
      );

      return state;
    }

    setStatus(
      state,
      'idle'
    );

    state.observer.observe(
      status
    );

    return state;
  };

  const initializeRoot = (
    root
  ) => {
    const shopifySection =
      root.closest(
        '.shopify-section'
      );

    if (!shopifySection) {
      return;
    }

    const existingState =
      stateBySection.get(
        shopifySection
      );

    if (
      existingState &&
      existingState.root === root &&
      existingState.productList.isConnected
    ) {
      return;
    }

    if (existingState) {
      cleanupState(
        existingState
      );
    }

    const state =
      createState(root);

    if (state) {
      stateBySection.set(
        shopifySection,
        state
      );
    }
  };

  const refresh = () => {
    document
      .querySelectorAll(
        SELECTORS.root
      )
      .forEach(
        initializeRoot
      );
  };

  const scheduleRefresh = () => {
    window.clearTimeout(
      refreshTimer
    );

    refreshTimer =
      window.setTimeout(
        refresh,
        50
      );
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      refresh,
      {
        once: true
      }
    );
  } else {
    refresh();
  }

  const mutationObserver =
    new MutationObserver(
      scheduleRefresh
    );

  mutationObserver.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleRefresh
  );
})();